<div id="search-bar-response-view" class="search-wrapper" (keydown)="onKeydown($event)">
  <div class="search-input">
    <button
      data-fs-element="Open-Search-Submit-FindIdea"
      mat-icon-button
      class="search-btn"
      tabindex="-1"
    >
      <mat-icon fontIcon="search" class="icon-m"></mat-icon>
    </button>
    <input
      type="text"
      data-fs-element="Open-Search-Input-FindIdea"
      [placeholder]="'OPEN_SEARCH.SEARCH_BY_KEYWORD' | translate"
      [value]="query()"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="close()"
      class="body-medium"
    />
  </div>

  @if (open() && filtered().length > 0) {
    <div class="suggestions-panel">
      @for (item of filtered(); track item.interactionIndex + item.matchType; let i = $index) {
        <div
          class="suggestion-item flex flex-center"
          [class.suggestion-item--highlighted]="highlightedIndex() === i"
          (mousedown)="select(item)"
          (mouseenter)="highlightedIndex.set(i)"
          (mouseleave)="highlightedIndex.set(-1)"
        >
          <div>
            <mat-icon class="black" fontIcon="chat_bubble_outline"></mat-icon>
          </div>
          <div>
            @if (item.matchType === 'question') {
              <div class="title title-small bold">
                @for (part of getTitleParts(item.highlightTitle); track $index) {
                  <span [class.highlight]="part.highlight">{{ part.text }}</span>
                }
              </div>
              @if (item.responsePreview) {
                <div class="description label-medium">{{ item.responsePreview }}</div>
              }
            } @else if (item.matchType === 'both') {
              <div class="title title-small bold">
                @for (part of getTitleParts(item.highlightTitle); track $index) {
                  <span [class.highlight]="part.highlight">{{ part.text }}</span>
                }
              </div>
              @if (item.snippetParts.length) {
                <div class="description label-medium">
                  @for (part of item.snippetParts; track $index) {
                    <span [class.highlight]="part.highlight">{{ part.text }}</span>
                  }
                </div>
              }
            } @else {
              <div class="title title-small bold">{{ item.highlightTitle }}</div>
              @if (item.snippetParts.length) {
                <div class="description label-medium">
                  @for (part of item.snippetParts; track $index) {
                    <span [class.highlight]="part.highlight">{{ part.text }}</span>
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  }

  @if (open() && query().length >= 2 && filtered().length === 0) {
    <div class="suggestions-panel suggestions-panel--empty">
      <div class="empty-state">
        <mat-icon fontIcon="search_off" class="icon-m"></mat-icon>
        <span>No results for "{{ query() }}"</span>
      </div>
    </div>
  }
</div>
